export const pizzaIngredients = [
  {
    key: "Albahaca",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Albahaca",
  },
  {
    key: "Aceitunas verdes",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Aceitunas verdes",
  },
  {
    key: "Aceitunas negras",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Aceitunas negras",
  },
  {
    key: "Bocadillo",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Bocadillo",
  },
  {
    key: "Cebolla caramelizada",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Cebolla caramelizada",
  },
  {
    key: "Cebolla roja",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Cebolla roja",
  },
  {
    key: "Cebolla blanca",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Cebolla blanca",
  },
  {
    key: "Champiñones",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Champiñones",
  },
  {
    key: "Espinaca",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Espinaca",
  },
  {
    key: "Maiz",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Maiz",
  },
  {
    key: "Piña",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Piña",
  },
  {
    key: "Pimenton verde",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Pimenton verde",
  },
  {
    key: "Pimenton rojo",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Pimenton rojo",
  },
  {
    key: "Queso parmesano",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Queso parmesano",
  },
  {
    key: "Tomate",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Tomate",
  },
  {
    key: "Tomate cherry",
    value: {
      personal: 1500,
      pequeña: 2000,
      mediana: 2500,
      grande: 3500,
    },
    text: "Tomate cherry",
  },
];
